import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueGtag from 'vue-gtag'
import './fonts.css'

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: {
    id: 'G-QB79RSC2K1'
  }
})

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
